import { render, staticRenderFns } from "./TokenClaimModal.vue?vue&type=template&id=766b10fa&scoped=true&"
import script from "./TokenClaimModal.vue?vue&type=script&lang=js&"
export * from "./TokenClaimModal.vue?vue&type=script&lang=js&"
import style0 from "./TokenClaimModal.vue?vue&type=style&index=0&id=766b10fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b10fa",
  null
  
)

export default component.exports